import React from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown,
  ValidatedTextInputV2,
} from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';
import { CONCENTRATION, CONCENTRATION_UNIT, UNITS } from 'src/constants/forms';

import { getInputValidators } from '../validators';
import messages from '../../messages';

const DropdownWithInputComponent = ({
  formData,
  onChangeData,
  fieldName,
  dropdownName,
  plateSizeDetails,
}) => {
  const units =
    dropdownName === CONCENTRATION_UNIT ? UNITS.concentration : UNITS.volume;
  const labelMsg =
    fieldName === CONCENTRATION ? messages.concentration : messages.volume;

  return (
    <div className="normalization__input-dropdown-group">
      <ValidatedTextInputV2
        data-testid={`normalization__input-${fieldName}`}
        label={<Message message={labelMsg} />}
        required
        validators={getInputValidators(formData, fieldName, dropdownName, plateSizeDetails)}
        showOnlyOneError
        value={formData[fieldName]?.value}
        onChange={(value, e, canValidate, isValid) => onChangeData(value, fieldName, isValid)}
        initialValidation={!!formData[fieldName]?.value}
      />
      <Dropdown
        onSelect={(option) => onChangeData(option.value, dropdownName, true)}
        selectedOptions={units.find((unit) => unit.value === formData[dropdownName]?.value)}
      >
        {units.map(({ label, value }) => (
          <option key={value} value={value} selected={value}>
            {label}
          </option>
        ))}
      </Dropdown>
    </div>
  );
};

DropdownWithInputComponent.propTypes = {
  formData: PropTypes.object,
  onChangeData: PropTypes.func.isRequired,
  fieldName: PropTypes.string.isRequired,
  dropdownName: PropTypes.string.isRequired,
  plateSizeDetails: PropTypes.object.isRequired,
};

export default DropdownWithInputComponent;
